import { render, staticRenderFns } from "./yzwjsqItem.vue?vue&type=template&id=21913be0&scoped=true"
import script from "./yzwjsqItem.vue?vue&type=script&lang=js"
export * from "./yzwjsqItem.vue?vue&type=script&lang=js"
import style0 from "./yzwjsqItem.vue?vue&type=style&index=0&id=21913be0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21913be0",
  null
  
)

export default component.exports